<style lang="less" scoped>
@import '../../../style/common/variable';
.CategoryList{position: relative;width: 100%;display: flex;flex-direction: column;font-family: AlibabaPuHuiTi-Medium;}
.first{display: flex;flex-direction: column;width: 830px;margin-right: 20px;margin-bottom: 30px;}
ul{list-style: none;margin: 0px;margin-left:-40px;margin-top: 0px;}
.imgTitleContent{text-align: left;}
.el-button{width: 800px;font-size: 16px;background-image: linear-gradient(#ECFAFF, #ECF6FF);}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .more-btn {width: 100vw; }
}
</style>

<template>
  <div class="CategoryList">
    <Navigation :navigationdatas="navigationList"></Navigation>
    <div class="first">
      <ul>
        <li v-for="(item,index) in imgTitleContentdata" :key ="index">
          <ImgTitleContent class="imgTitleContent" :imgTitleContentItem = "item" @handleClick="goDetails"></ImgTitleContent>
        </li>
      </ul>
    </div>
    <el-button class="more-btn" @click="getOthers">加载更多</el-button>
  </div>
</template>

<script>
/**
 * 何宽
 * 矿业资讯列表页面
 */
import ImgTitleContent from '../assembly/ImgTitleContent.vue'
import Navigation from '../assembly/Navigation.vue'
export default {
  components: {
    ImgTitleContent,
    Navigation
  },
  name: '',
  data()
  {
    return {
      categorydata: [], // 不同类别的数据
      imgTitleContentdata: [], //列表页数据
      num1: null,
      num2: null,
      currentPage: 1,
      navigationList: [
        {theme: '首页', path: '/Kyforum'},
        {theme: '矿业资讯', path: '/KyzxIndex'},
        {theme: '', path: ''}
      ]
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.num1 = +nval.query.catid
        this.num2 = +nval.query.ssgj
        this.getCategoryList()
      },
      immediate: true
    }
  },
  methods: {
    // 从矿业资讯的数据表中获取需要在展示的分类浏览下不同分类的数据
    getCategoryList()
    {
      if (this.num1 === 0) //Kyforum.vue 中查看更多咨询数据
      {
        let paras = {cmd: 'queryUnion', _major: 11, _minor: 1, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: 'B.id=A.catid and A.examine = 0', orderby: 'addtime DESC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          ret[0].data.forEach(item =>
          {
            this.categorydata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布', time: item.addtime, description: '来源', value: item.copyfrom})
          })
          this.imgTitleContentdata = this.categorydata
        })
      }
      else if (this.num1 === 1)
      {
        if (this.num2 === 2) //KyzxIndex.vue 和 TabsCard.vue 中“国内资讯”查看更多数据
        {
          let paras = {cmd: 'queryUnion', _major: 11, _minor: 1, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: 'A.ssgj=2 and B.id=A.catid and A.examine = 0', orderby: 'addtime DESC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
          window.post.getPost(paras).then((ret) =>
          {
            ret[0].data.forEach(item =>
            {
              this.categorydata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布', time: item.addtime, description: '来源', value: item.copyfrom})
            })
            this.imgTitleContentdata = this.categorydata
          })
        }
        else if (this.num2 === 13) //KyzxIndex.vue 和 TabsCard.vue 中“国际资讯”查看更多数据
        {
          let paras = {cmd: 'queryUnion', _major: 11, _minor: 1, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: 'A.ssgj=13 and B.id=A.catid and A.examine = 0', orderby: 'addtime DESC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
          window.post.getPost(paras).then((ret) =>
          {
            ret[0].data.forEach(item =>
            {
              this.categorydata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布', time: item.addtime, description: '来源', value: item.copyfrom})
            })
            this.imgTitleContentdata = this.categorydata
          })
        }
        else if (this.num2 === 0) //TabsCard.vue 中“东盟资讯”查看更多数据
        {
          let paras = {cmd: 'queryUnion', _major: 11, _minor: 1, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: 'A.ssgj>2 and A.ssgj<13 and B.id=A.catid and A.examine = 0', orderby: 'addtime DESC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
          window.post.getPost(paras).then((ret) =>
          {
            ret[0].data.forEach(item =>
            {
              this.categorydata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布', time: item.addtime, description: '来源', value: item.copyfrom})
            })
            this.imgTitleContentdata = this.categorydata
          })
        }
        else //KyzxIndex.vue 中“东盟资讯”查看更多数据
        {
          let paras = {cmd: 'queryUnion', _major: 11, _minor: 1, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: 'A.ssgj=? and B.id=A.catid and A.examine = 0', types: 'i', vals: this.num2, orderby: 'addtime DESC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
          window.post.getPost(paras).then((ret) =>
          {
            ret[0].data.forEach(item =>
            {
              this.categorydata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布', time: item.addtime, description: '来源', value: item.copyfrom})
            })
            this.imgTitleContentdata = this.categorydata
          })
        }
      }
      else //Kyzx.vue 中查看更多咨询数据
      {
        let paras = {cmd: 'queryUnion', _major: 11, _minor: 1, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: 'B.id=? and B.id=A.catid and A.examine = 0', types: 'i', vals: this.num1, orderby: 'addtime DESC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          ret[0].data.forEach(item =>
          {
            this.categorydata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布', time: item.addtime, description: '来源', value: item.copyfrom})
          })
          this.imgTitleContentdata = this.categorydata
        })
      }
    },
    // 点击加载更多，依次添加10条数据，并重新渲染然页面展示数据
    getOthers()
    {
      this.currentPage++
      this.getCategoryList()
    },
    // 跳转到矿业资讯详情页面，并将被点击的新闻的id传递到详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/KyzxDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/KyzxList.vue